<template>
  <b-card no-body class="h-100">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h5 class="mb-0">
        <feather-icon icon="ListIcon" size="16" class="mr-50" />
        {{ $t('Upcoming maintenances') }}
      </h5>
      <b-badge v-if="overdueCount > 0" variant="danger" pill>
        {{ overdueCount }}
      </b-badge>
    </div>

    <b-card-body class="p-0">
      <div v-if="loading" class="text-center py-2">
        <b-spinner small variant="primary" />
      </div>

      <div v-else-if="items.length === 0" class="text-center text-muted py-2 px-1">
        {{ $t('No registered maintenance') }}
      </div>

      <div v-else class="upcoming-list">
        <div
          v-for="item in items"
          :key="item.id || `${item.planName}-${item.name}`"
          class="upcoming-item"
        >
          <div class="upcoming-item-main">
            <div class="font-weight-bold text-truncate" v-b-tooltip.hover :title="item.name">
              {{ item.name }}
            </div>
            <small class="text-muted text-truncate d-block">{{ item.planName }}</small>
          </div>
          <div class="upcoming-item-meta text-right">
            <b-badge :variant="statusMeta(item.status).variant" pill class="mb-25">
              {{ $t(statusMeta(item.status).labelKey) }}
            </b-badge>
            <div class="small" :class="`text-${statusMeta(item.status).variant}`">
              {{ item.remaining > 0 ? $t('Remaining:') : $t('Overdue:') }}
              {{ formatMetric(Math.abs(item.remaining)) }} {{ item.unit }}
            </div>
            <div class="small text-muted">
              {{ $t('Scheduled') }}: {{ formatMetric(item.scheduledValue) }} {{ item.unit }}
            </div>
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BBadge, BCard, BCardBody, BSpinner, VBTooltip } from 'bootstrap-vue'
import { STATUS_META } from '../maintenanceUtils'

export default {
  name: 'UpcomingMaintenancesCard',
  components: { BBadge, BCard, BCardBody, BSpinner },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    items: { type: Array, default: () => [] },
    overdueCount: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    formatMetric: { type: Function, required: true },
  },
  setup() {
    const statusMeta = status => STATUS_META[status] || STATUS_META.onTime
    return { statusMeta }
  },
}
</script>

<style lang="scss" scoped>
.upcoming-list {
  max-height: 360px;
  overflow-y: auto;
}

.upcoming-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.85rem 1.25rem;
  border-bottom: 1px solid #ebe9f1;

  &:last-child { border-bottom: 0; }
}

.upcoming-item-main {
  min-width: 0;
  flex: 1;
}

.upcoming-item-meta {
  flex-shrink: 0;
}
</style>
